import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const Ctx = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "ovamx:user_token";

function loadToken() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
function saveToken(t) {
  try { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY); } catch {}
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(loadToken());
  const [user, setUser] = useState(null); // null=loading, false=guest, object=authenticated

  useEffect(() => {
    if (!token) { setUser(false); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { saveToken(null); setToken(null); setUser(false); });
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    saveToken(data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, extras = {}) => {
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name, ...extras });
    saveToken(data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    saveToken(null);
    setToken(null);
    setUser(false);
  };

  const refresh = async () => {
    if (!token) return;
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(data);
      return data;
    } catch {}
  };

  const apiHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <Ctx.Provider value={{ user, token, login, register, logout, refresh, apiHeaders, API }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
